import styled from "styled-components";

export const StyledRoundedOverflowXWrapper = styled.div`
  overflow-x: auto;
  border-radius: ${(props) => props.theme.radius.normal};
`;
